import { render, staticRenderFns } from "./customer-information-request.vue?vue&type=template&id=56dcc98d&scoped=true&"
import script from "./customer-information-request.vue?vue&type=script&lang=js&"
export * from "./customer-information-request.vue?vue&type=script&lang=js&"
import style0 from "./customer-information-request.vue?vue&type=style&index=0&id=56dcc98d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dcc98d",
  null
  
)

export default component.exports